export const environment = {
   production: true,
   apiUrl: 'https://api.woorky.io/',
   apiUAT: 'http://localhost:3000/',
   viaCepUrl: 'https://viacep.com.br/ws/',
}
